export default __webpack_public_path__ + "dd280c8a7aa464beeccc78df18fd16df.wasm";